import { FilmFilterKey } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { carouselConfigValidator } from '../../../subcomponents/carousel/types/config';
import { structuredDataConfigValidator } from '../../../types/structured-data-config';
import { getComponentFilterConfigValidator } from '../../../validators/component-filter-config';
import { defaultFilmThumbnailConfig, filmThumbnailConfigValidatorSchema } from '../../film/thumbnail/types/config';
import { FilmThumbnailMediaType } from '../../film/thumbnail/types/media-type';
import { defaultFilmTrailerConfig, filmTrailerConfigValidatorSchema } from '../../film/trailer/types/config';
/**
 * Mode options for the Film List component
 */
export var FilmListMode;
(function (FilmListMode) {
    FilmListMode["Grid"] = "Grid";
    FilmListMode["Carousel"] = "Carousel";
})(FilmListMode || (FilmListMode = {}));
/**
 * Default configuration options for the Film List Carousel component
 */
export const defaultFilmListCarouselConfig = {
    showDots: false,
    refreshOnUpdate: true,
    settings: {
        slidesToShow: 2.2,
        slidesToScroll: 'auto',
        responsive: [
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 3.2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4.2
                }
            },
            {
                breakpoint: 950,
                settings: {
                    slidesToShow: 5.2
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6.2
                }
            }
        ]
    }
};
/**
 * Default configuration options for the Film List component
 */
export const defaultFilmListConfig = Object.assign(Object.assign({}, defaultFilmThumbnailConfig), { mode: FilmListMode.Grid, carousel: defaultFilmListCarouselConfig, structuredData: { enable: false }, playTrailerButton: Object.assign(Object.assign({}, defaultFilmTrailerConfig), { show: true }) });
export const filmListConfigValidator = Validator.object(Object.assign(Object.assign({}, filmThumbnailConfigValidatorSchema), { mode: Validator.oneOf(Object.values(FilmListMode)), mediaType: Validator.oneOf(Object.values(FilmThumbnailMediaType)), filmUrlFactory: Validator.optional(Validator.fn()), componentId: Validator.optional(Validator.string()), maximumFilms: Validator.optional(Validator.number({ min: 1 })), filter: getComponentFilterConfigValidator(Object.values(FilmFilterKey)), carousel: carouselConfigValidator, structuredData: structuredDataConfigValidator, playTrailerButton: Validator.object(Object.assign(Object.assign({}, filmTrailerConfigValidatorSchema), { show: Validator.boolean() })) }));
